import React, { useMemo } from 'react';
import FilterSelect from './FilterSelect';

type Props = {
  countries: string[];
  value: string;
  onChange: (country: string) => void;
  placeholder?: string;
};

const CountryFilterSelect: React.FC<Props> = ({
  countries,
  value,
  onChange,
  placeholder = 'Все страны',
}) => {
  const options = useMemo(
    () => countries.map((c) => ({ value: c, label: c })),
    [countries]
  );

  return (
    <FilterSelect
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default CountryFilterSelect;
